import React from "react";
import OurGrowth from "./OurGrowth";
import { Box, Button, Stack, Typography } from "@mui/material";
const PartnerPrivileges = () => {
  return (
    <>
      {/* desktop  */}
      <Stack
        display={{
          xs: "none",
          sm: "none",
          md: "none",
          lg: "flex",
        }}
        pb={5}
        sx={{
          justifyContent: "start",
          alignItems: "center",
          backgroundColor: "#E7EDFF",
        }}
      >
        {/* <OurGrowth /> */}
        <Typography
          sx={{
            // left: "100px",
            fontFamily: "Work Sans",
            fontSize: "40px",
            fontWeight: 600,
            lineHeight: "43px",
            letterSpacing: "0em",
            textAlign: "left",
          }}
          mt={3}
        >
          Partner privileges
        </Typography>
        <Stack
          justifyContent={"center"}
          alignItems={"flex-start"}
          width={"90%"}
          direction={"row"}
          gap={3}
          sx={{
            padding: " 40px 0 80px 0",
            borderBottom: "1px solid #000000",
          }}
        >
          <Stack
            direction="row"
            sx={{
              width: "50%",

              flexWrap: "wrap",
              gap: 1,
            }}
          >
            <Button
              sx={{
                width: "154px",
                height: "47px",
                padding: "15px 24px 15px 24px",
                borderRadius: "41.95px",
                gap: "6.66px",
                backgroundColor: "#F15B25",
                color: "#FFFFFF",
                "&:hover": {
                  backgroundColor: "#FFFFFF",
                  color: "#F15B25",
                  border: "1px solid #F15B25",
                },
              }}
            >
              <Typography
                sx={{
                  fontFamily: "Work Sans",
                  fontSize: "12px",
                  fontWeight: 500,
                  lineHeight: "17px",
                  letterSpacing: "-0.02em",
                  textAlign: "center",
                }}
              >
                Partner Portal
              </Typography>
            </Button>

            <Button
              sx={{
                width: "154px",
                height: "47px",
                padding: "15px 24px 15px 24px",
                borderRadius: "41.95px",
                gap: "6.66px",
                backgroundColor: "#F15B25",
                opacity: "70%",
                color: "#FFFFFF",
                "&:hover": {
                  backgroundColor: "#FFFFFF",
                  color: "#F15B25",
                  border: "1px solid #F15B25",
                },
              }}
            >
              <Typography
                sx={{
                  fontFamily: "Work Sans",
                  fontSize: "12px",
                  fontWeight: 500,
                  lineHeight: "17px",
                  letterSpacing: "-0.02em",
                  textAlign: "center",
                }}
              >
                Partner Portal
              </Typography>
            </Button>
            <Button
              sx={{
                width: "154px",
                height: "47px",
                padding: "15px 24px 15px 24px",
                borderRadius: "41.95px",
                gap: "6.66px",
                backgroundColor: "#F15B25",
                opacity: "70%",
                color: "#FFFFFF",
                "&:hover": {
                  backgroundColor: "#FFFFFF",
                  color: "#F15B25",
                  border: "1px solid #F15B25",
                },
              }}
            >
              <Typography
                sx={{
                  fontFamily: "Work Sans",
                  fontSize: "12px",
                  fontWeight: 500,
                  lineHeight: "17px",
                  letterSpacing: "-0.02em",
                  textAlign: "center",
                }}
              >
                Partner Portal
              </Typography>
            </Button>
            <Button
              sx={{
                width: "154px",
                height: "47px",
                padding: "15px 24px 15px 24px",
                borderRadius: "41.95px",
                gap: "6.66px",
                backgroundColor: "#F15B25",
                opacity: "70%",
                color: "#FFFFFF",
                "&:hover": {
                  backgroundColor: "#FFFFFF",
                  color: "#F15B25",
                  border: "1px solid #F15B25",
                },
              }}
            >
              <Typography
                sx={{
                  fontFamily: "Work Sans",
                  fontSize: "12px",
                  fontWeight: 500,
                  lineHeight: "17px",
                  letterSpacing: "-0.02em",
                  textAlign: "center",
                }}
              >
                Partner Portal
              </Typography>
            </Button>
            <Button
              sx={{
                width: "154px",
                height: "47px",
                padding: "15px 24px 15px 24px",
                borderRadius: "41.95px",
                gap: "6.66px",
                backgroundColor: "#F15B25",
                opacity: "70%",
                color: "#FFFFFF",
                "&:hover": {
                  backgroundColor: "#FFFFFF",
                  color: "#F15B25",
                  border: "1px solid #F15B25",
                },
              }}
            >
              <Typography
                sx={{
                  fontFamily: "Work Sans",
                  fontSize: "12px",
                  fontWeight: 500,
                  lineHeight: "17px",
                  letterSpacing: "-0.02em",
                  textAlign: "center",
                }}
              >
                Partner Portal
              </Typography>
            </Button>
            <Button
              sx={{
                width: "154px",
                height: "47px",
                padding: "15px 24px 15px 24px",
                borderRadius: "41.95px",
                gap: "6.66px",
                backgroundColor: "#F15B25",
                opacity: "70%",
                color: "#FFFFFF",
                "&:hover": {
                  backgroundColor: "#FFFFFF",
                  color: "#F15B25",
                  border: "1px solid #F15B25",
                },
              }}
            >
              <Typography
                sx={{
                  fontFamily: "Work Sans",
                  fontSize: "12px",
                  fontWeight: 500,
                  lineHeight: "17px",
                  letterSpacing: "-0.02em",
                  textAlign: "center",
                }}
              >
                Partner Portal
              </Typography>
            </Button>
            <Button
              sx={{
                width: "154px",
                height: "47px",
                padding: "15px 24px 15px 24px",
                borderRadius: "41.95px",
                gap: "6.66px",
                backgroundColor: "#F15B25",
                opacity: "70%",
                color: "#FFFFFF",
                "&:hover": {
                  backgroundColor: "#FFFFFF",
                  color: "#F15B25",
                  border: "1px solid #F15B25",
                },
              }}
            >
              <Typography
                sx={{
                  fontFamily: "Work Sans",
                  fontSize: "12px",
                  fontWeight: 500,
                  lineHeight: "17px",
                  letterSpacing: "-0.02em",
                  textAlign: "center",
                }}
              >
                Partner Portal
              </Typography>
            </Button>
            <Button
              sx={{
                width: "154px",
                height: "47px",
                padding: "15px 24px 15px 24px",
                borderRadius: "41.95px",
                gap: "6.66px",
                backgroundColor: "#F15B25",
                opacity: "70%",
                color: "#FFFFFF",
                "&:hover": {
                  backgroundColor: "#FFFFFF",
                  color: "#F15B25",
                  border: "1px solid #F15B25",
                },
              }}
            >
              <Typography
                sx={{
                  fontFamily: "Work Sans",
                  fontSize: "12px",
                  fontWeight: 500,
                  lineHeight: "17px",
                  letterSpacing: "-0.02em",
                  textAlign: "center",
                }}
              >
                Partner Portal
              </Typography>
            </Button>
          </Stack>

          <Box
            sx={{
              width: "50%",
            }}
          >
            <Typography
              sx={{
                fontFamily: "Work Sans",
                fontSize: "25px",
                fontWeight: 600,
                lineHeight: "27px",
                letterSpacing: "0em",
                textAlign: "left",
                color: "#052973",
                marginTop: "20px",
              }}
            >
              Partner Portal
            </Typography>
            <Typography
              sx={{
                fontFamily: "Work Sans",
                fontSize: "18px",
                fontWeight: 400,
                lineHeight: "27px",
                letterSpacing: "0em",
                textAlign: "left",
              }}
            >
              {" "}
              Easily access all your sales and marketing tools and training
              resources in a central hub designed specifically for Partners.
            </Typography>
            <Typography sx={{ color: "#F15B25" }}>Read more</Typography>
          </Box>
        </Stack>
        <Stack
          width={"90%"}
          direction="row"
          gap={4}
          sx={{
            alignItems: "center",
            justifyContent: "center",
            maxWidth: "1100px",
            marginTop: "50px",
          }}
        >
          <Box>
            <Typography
              sx={{
                fontFamily: "Work Sans",
                fontSize: "25px",
                fontWeight: 600,
                lineHeight: "32px",
                letterSpacing: "0em",
                textAlign: "left",
                width: "273px",
              }}
            >
              Additional Partner Enablement Programs
            </Typography>
          </Box>
          <Box>
            <Typography
              sx={{
                fontFamily: "Work Sans",
                fontSize: "14px",
                fontWeight: 400,
                lineHeight: "21px",
                letterSpacing: "0em",
                textAlign: "left",
              }}
            >
              Meet Zoho product experts, PAMs, and leadership at Zoholics and
              Inspire.
            </Typography>
          </Box>
          <Box>
            <Typography
              sx={{
                fontFamily: "Work Sans",
                fontSize: "14px",
                fontWeight: 400,
                lineHeight: "21px",
                letterSpacing: "0em",
                textAlign: "left",
              }}
            >
              Engage with customers through exclusive meetups and co-sponsored
              events.
            </Typography>
          </Box>
          <Box>
            <Typography
              sx={{
                fontFamily: "Work Sans",
                fontSize: "14px",
                fontWeight: 400,
                lineHeight: "21px",
                letterSpacing: "0em",
                textAlign: "left",
              }}
            >
              Stay up to date on everything Zoho with dedicated Zoho Partner
              Connect and Cliq channels.
            </Typography>
          </Box>
        </Stack>
      </Stack>
      {/* mobile  */}
      <Stack
        display={{
          xs: "flex",
          sm: "flex",
          md: "flex",
          lg: "none",
        }}
        sx={{
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "#E7EDFF",
        }}
      >
        {/* <OurGrowth /> */}

        <Stack direction={"column"} gap={1} width={"95%"}>
          <Typography
            mt={"20px"}
            sx={{
              fontFamily: "Work Sans",
              fontSize: {
                xs: "24px",
                md: "30px",
                lg: "40px",
              },
              fontWeight: 600,
              lineHeight: "43px",
              letterSpacing: "0em",
              textAlign: "center",
            }}
          >
            Partner privileges
          </Typography>
          <Stack
            alignSelf={"center"}
            direction="row"
            justifyContent={"center"}
            sx={{
              width: "95%",
              height: "100%",
              flexWrap: "wrap",
              gap: 1,
            }}
          >
            <Button
              sx={{
                width: {
                  xs: "130px",
                  sm: "130px",
                  lg: "154px",
                },

                padding: {
                  xs: "7px 12px 7px 12px",
                },
                borderRadius: "30px",
                gap: "6.66px",
                backgroundColor: "#F15B25",
                color: "#FFFFFF",
                "&:hover": {
                  backgroundColor: "#FFFFFF",
                  color: "#F15B25",
                  border: "1px solid #F15B25",
                },
              }}
            >
              <Typography
                sx={{
                  fontFamily: "Work Sans",
                  fontSize: "12px",
                  fontWeight: 500,
                  lineHeight: "17px",
                  letterSpacing: "-0.02em",
                  textAlign: "center",
                }}
              >
                Partner Portal
              </Typography>
            </Button>
            <Button
              sx={{
                width: {
                  xs: "130px",
                  sm: "130px",
                  lg: "154px",
                },

                padding: {
                  xs: "7px 12px 7px 12px",
                },
                borderRadius: "30px",
                gap: "6.66px",
                backgroundColor: "#F15B25",
                opacity: "70%",
                color: "#FFFFFF",
                "&:hover": {
                  backgroundColor: "#FFFFFF",
                  color: "#F15B25",
                  border: "1px solid #F15B25",
                },
              }}
            >
              <Typography
                sx={{
                  fontFamily: "Work Sans",
                  fontSize: "12px",
                  fontWeight: 500,
                  lineHeight: "17px",
                  letterSpacing: "-0.02em",
                  textAlign: "center",
                }}
              >
                Partner Portal
              </Typography>
            </Button>

            <Button
              sx={{
                width: {
                  xs: "130px",
                  sm: "130px",
                  lg: "154px",
                },

                padding: {
                  xs: "7px 12px 7px 12px",
                },
                borderRadius: "30px",
                gap: "6.66px",
                backgroundColor: "#F15B25",
                opacity: "70%",
                color: "#FFFFFF",
                "&:hover": {
                  backgroundColor: "#FFFFFF",
                  color: "#F15B25",
                  border: "1px solid #F15B25",
                },
              }}
            >
              <Typography
                sx={{
                  fontFamily: "Work Sans",
                  fontSize: "12px",
                  fontWeight: 500,
                  lineHeight: "17px",
                  letterSpacing: "-0.02em",
                  textAlign: "center",
                }}
              >
                Partner Portal
              </Typography>
            </Button>

            <Button
              sx={{
                width: {
                  xs: "130px",
                  sm: "130px",
                  lg: "154px",
                },

                padding: {
                  xs: "7px 12px 7px 12px",
                },
                borderRadius: "30px",
                gap: "6.66px",
                backgroundColor: "#F15B25",
                opacity: "70%",
                color: "#FFFFFF",
                "&:hover": {
                  backgroundColor: "#FFFFFF",
                  color: "#F15B25",
                  border: "1px solid #F15B25",
                },
              }}
            >
              <Typography
                sx={{
                  fontFamily: "Work Sans",
                  fontSize: "12px",
                  fontWeight: 500,
                  lineHeight: "17px",
                  letterSpacing: "-0.02em",
                  textAlign: "center",
                }}
              >
                Partner Portal
              </Typography>
            </Button>

            <Button
              sx={{
                width: {
                  xs: "130px",
                  sm: "130px",
                  lg: "154px",
                },

                padding: {
                  xs: "7px 12px 7px 12px",
                },
                borderRadius: "30px",
                gap: "6.66px",
                backgroundColor: "#F15B25",
                opacity: "70%",
                color: "#FFFFFF",
                "&:hover": {
                  backgroundColor: "#FFFFFF",
                  color: "#F15B25",
                  border: "1px solid #F15B25",
                },
              }}
            >
              <Typography
                sx={{
                  fontFamily: "Work Sans",
                  fontSize: "12px",
                  fontWeight: 500,
                  lineHeight: "17px",
                  letterSpacing: "-0.02em",
                  textAlign: "center",
                }}
              >
                Partner Portal
              </Typography>
            </Button>

            <Button
              sx={{
                width: {
                  xs: "130px",
                  sm: "130px",
                  lg: "154px",
                },

                padding: {
                  xs: "7px 12px 7px 12px",
                },
                borderRadius: "30px",
                gap: "6.66px",
                backgroundColor: "#F15B25",
                opacity: "70%",
                color: "#FFFFFF",
                "&:hover": {
                  backgroundColor: "#FFFFFF",
                  color: "#F15B25",
                  border: "1px solid #F15B25",
                },
              }}
            >
              <Typography
                sx={{
                  fontFamily: "Work Sans",
                  fontSize: "12px",
                  fontWeight: 500,
                  lineHeight: "17px",
                  letterSpacing: "-0.02em",
                  textAlign: "center",
                }}
              >
                Partner Portal
              </Typography>
            </Button>

            <Button
              sx={{
                width: {
                  xs: "130px",
                  sm: "130px",
                  lg: "154px",
                },

                padding: {
                  xs: "7px 12px 7px 12px",
                },
                borderRadius: "30px",
                gap: "6.66px",
                backgroundColor: "#F15B25",
                opacity: "70%",
                color: "#FFFFFF",
                "&:hover": {
                  backgroundColor: "#FFFFFF",
                  color: "#F15B25",
                  border: "1px solid #F15B25",
                },
              }}
            >
              <Typography
                sx={{
                  fontFamily: "Work Sans",
                  fontSize: "12px",
                  fontWeight: 500,
                  lineHeight: "17px",
                  letterSpacing: "-0.02em",
                  textAlign: "center",
                }}
              >
                Partner Portal
              </Typography>
            </Button>

            <Button
              sx={{
                width: {
                  xs: "130px",
                  sm: "130px",
                  lg: "154px",
                },

                padding: {
                  xs: "7px 12px 7px 12px",
                },
                borderRadius: "30px",
                gap: "6.66px",
                backgroundColor: "#F15B25",
                opacity: "70%",
                color: "#FFFFFF",
                "&:hover": {
                  backgroundColor: "#FFFFFF",
                  color: "#F15B25",
                  border: "1px solid #F15B25",
                },
              }}
            >
              <Typography
                sx={{
                  fontFamily: "Work Sans",
                  fontSize: "12px",
                  fontWeight: 500,
                  lineHeight: "17px",
                  letterSpacing: "-0.02em",
                  textAlign: "center",
                }}
              >
                Partner Portal
              </Typography>
            </Button>
          </Stack>

          <Box
            textAlign={"center"}
            margin={"0 auto"}
            sx={{
              width: "95%",
            }}
          >
            <Typography
              textAlign={"center"}
              sx={{
                fontFamily: "Work Sans",
                fontSize: "25px",
                fontWeight: 600,
                lineHeight: "27px",
                letterSpacing: "0em",

                color: "#052973",
                marginTop: "20px",
              }}
            >
              Partner Portal
            </Typography>
            <Typography
              textAlign={"center"}
              sx={{
                fontFamily: "Work Sans",
                fontSize: "14px",
                fontWeight: 400,
                lineHeight: "27px",
                letterSpacing: "0em",
              }}
            >
              {" "}
              Easily access all your sales and marketing tools and training
              resources in a central hub designed specifically for Partners.
            </Typography>
            <Typography sx={{ color: "#F15B25" }}>Read more</Typography>
          </Box>
        </Stack>
        <Stack
          width={"95%"}
          direction="column"
          sx={{
            alignItems: "center",
            justifyContent: "center",
          }}
          mt={3}
          mb={3}
          gap={2}
        >
          <Box>
            <Typography
              sx={{
                fontFamily: "Work Sans",
                fontSize: "25px",
                fontWeight: 600,
                lineHeight: "32px",
                letterSpacing: "0em",
                textAlign: "center",
              }}
            >
              Additional Partner Enablement Programs
            </Typography>
          </Box>
          <Stack width={"85%"}>
            {/* <Box width={"2px"} height={"2px"} backgroundColor={"green"} /> */}
            <Typography
              sx={{
                fontFamily: "Work Sans",
                fontSize: "14px",
                fontWeight: 400,
                lineHeight: "21px",
                letterSpacing: "0em",
                textAlign: "left",
              }}
            >
              Meet Zoho product experts, PAMs, and leadership at Zoholics and
              Inspire.
            </Typography>
          </Stack>
          <Stack width={"85%"}>
            <Typography
              sx={{
                fontFamily: "Work Sans",
                fontSize: "14px",
                fontWeight: 400,
                lineHeight: "21px",
                letterSpacing: "0em",
                textAlign: "left",
              }}
            >
              Engage with customers through exclusive meetups and co-sponsored
              events.
            </Typography>
          </Stack>
          <Stack width={"85%"}>
            <Typography
              sx={{
                fontFamily: "Work Sans",
                fontSize: "14px",
                fontWeight: 400,
                lineHeight: "21px",
                letterSpacing: "0em",
                textAlign: "left",
              }}
            >
              Stay up to date on everything Zoho with dedicated Zoho Partner
              Connect and Cliq channels.
            </Typography>
          </Stack>
        </Stack>
      </Stack>
    </>
  );
};

export default PartnerPrivileges;
